import { Download, ShieldCheck, BadgeDollarSign, FileBarChart2, Globe2, Headphones } from "lucide-react";

const FEATURES = [
  {
    icon: Download,
    title: "Instant PDF Delivery",
    body: "Pay and download in seconds. We also email a secure link in case you misplace the file.",
  },
  {
    icon: FileBarChart2,
    title: "Investor-Ready Financials",
    body: "Each plan includes 3-year projections, P&L, cash flow, and a polished SWOT analysis.",
  },
  {
    icon: BadgeDollarSign,
    title: "Funding-Ready Templates",
    body: "Submit straight to banks, private investors, or grant programmes. Built for approval.",
  },
  {
    icon: Globe2,
    title: "Global Currency Support",
    body: "Prices auto-display in USD, GBP, or EUR. Pay securely through Stripe or PayPal.",
  },
  {
    icon: ShieldCheck,
    title: "Expert-Backed Blueprints",
    body: "Every plan is meticulously researched by industry veterans to give you a professional edge. Join hundreds of founders who have used our frameworks to launch with confidence.",
  },
  {
    icon: Headphones,
    title: "Founders Support",
    body: "Email questions get a personalised response from the AIGL team within 24 hours.",
  },
];

export const WhySection = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="bg-[#F8FAFC] py-20 sm:py-28"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <span className="font-accent text-[#C5A059] text-xs">WHY AIGL CHANNEL</span>
            <h2 className="font-display text-4xl sm:text-5xl text-[#0A192F] mt-4 mb-6 leading-tight">
              The blueprint
              <br />
              <span className="italic">that opens doors.</span>
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              We've spent years packaging high-stakes business plans for entrepreneurs who
              had the vision but needed the structure investors require. Now those same
              plans are available as a single, affordable download.
            </p>
            <p className="text-slate-600 leading-relaxed">
              No subscriptions. No upsells. Pay once, own it forever.
            </p>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {FEATURES.map((f, i) => {
              const Icon = f.icon;
              return (
                <div
                  key={f.title}
                  data-testid={`feature-${i}`}
                  className="bg-white border border-slate-200 p-6 hover:border-[#C5A059] transition"
                >
                  <div className="w-10 h-10 border border-[#C5A059] flex items-center justify-center mb-4">
                    <Icon className="w-5 h-5 text-[#C5A059]" />
                  </div>
                  <h4 className="font-display text-lg text-[#0A192F] mb-2">{f.title}</h4>
                  <p className="text-sm text-slate-600 leading-relaxed">{f.body}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
